import React from 'react';
import PendingPreAssessments from './PendingPreAssessments';

export default function PendingExams() {
  return <PendingPreAssessments title="Pending Exams" type="exam" />;
}
